export function lightenHexColor(hex, 
/** A number between 0 a 1 */
lightenFactor) {
    const lengthBefore = hex.length;
    // Remove the '#' if it's there
    hex = hex.replace(/^#/, "");
    const hadHash = lengthBefore !== hex.length;
    // Convert 3-digit hex to 6-digit hex
    if (hex.length === 3) {
        hex = hex
            .split("")
            .map((x) => x + x)
            .join("");
    }
    if (hex.length < 6) {
        throw new Error("Invalid HEX color.");
    }
    // Convert hex to RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    // Calculate the amount to lighten
    const lighten = (color) => Math.round(color + (255 - color) * lightenFactor);
    // Lighten the RGB values
    const newR = lighten(r);
    const newG = lighten(g);
    const newB = lighten(b);
    // Convert back to hex and return
    const toHex = (color) => color.toString(16).padStart(2, "0");
    return [hadHash ? "#" : "", toHex(newR), toHex(newG), toHex(newB)].join("");
}
